import { render, staticRenderFns } from "./SkeletonEditField.vue?vue&type=template&id=4d5bd952"
import script from "./SkeletonEditField.vue?vue&type=script&lang=ts"
export * from "./SkeletonEditField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports